import React from 'react';
export const TabSetContext = React.createContext();